export default {
  title: {
    add: 'thêm ngân hàng',
    update: 'sửa đổi ngân hàng'
  },
  label: {
    bankAccount: 'chủ tài khoản',
    bankBranch: 'chi nhánh',
    bankName: 'tên ngân hàng',
    bankNo: 'số tài khoản',
    createBy: 'người tạo',
    createTime: 'thời gian tạo',
    id: 'mã chính ID',
    merchatNo: 'Tài khoản merchant',
    updateBy: 'người sửa đổi',
    updateTime: ' thời gian cập nhật',
    action: 'thao tác'
  },
  rules: {
    bankAccount: 'tên chủ tài khoản không được để trống',
    bankBranch: 'tên chi nhánh không được để trống',
    bankName: 'tên ngân hàng không được để trống',
    bankNo: {
      required: 'số tài khoản không được bỏ trống',
      type: 'số tài khoản phải là định dạng số',
      symboltype: 'số tài khoản phải là định dạng số',
      min: 'Độ dài trên 5 số',
      length: 'số tài khoản ngân hàng từ 4 dến 31'
    },
    merchatNo: 'tài khoản merchant không được để trống'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/withdrawBank.js